"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpRestrictionType = exports.FeatureActionType = exports.FeatureCode = void 0;
var FeatureCode;
(function (FeatureCode) {
    FeatureCode["VOUCHER"] = "voucher";
    FeatureCode["UPLOAD"] = "upload";
    FeatureCode["JOB"] = "job";
    FeatureCode["USER"] = "user";
    FeatureCode["ROLE"] = "role";
    FeatureCode["RULE"] = "rule";
    FeatureCode["FORMAT"] = "format";
    FeatureCode["FIELD"] = "field";
    FeatureCode["MODIFICATION"] = "modification";
    FeatureCode["PARTNER"] = "partner";
    FeatureCode["ACCOUNTING_TYPE"] = "accountingType";
    FeatureCode["TAX_DIV"] = "taxDiv";
    FeatureCode["RECIPIENT"] = "recipient";
    FeatureCode["INPUT"] = "input";
    FeatureCode["API"] = "api";
    FeatureCode["DEPARTMENT"] = "department";
    FeatureCode["TENANT"] = "tenant";
    FeatureCode["EXPRESS_CONFIG"] = "expressConfig";
    FeatureCode["LOGIN_LOG_FOR_ADMIN"] = "loginLogForAdmin";
    FeatureCode["DASHBOARD"] = "dashboard";
    FeatureCode["INPUT_MANAGEMENT"] = "inputManagement";
    FeatureCode["EXPORTER"] = "exporter";
    FeatureCode["EXTERNAL_MAPPING"] = "externalMapping";
    FeatureCode["VOUCHER_MAPPING"] = "voucherMapping";
    FeatureCode["MASTER_FORMAT"] = "masterFormat";
    FeatureCode["INBOX"] = "inbox";
    FeatureCode["IP_RESTRICTION"] = "ipRestriction";
    FeatureCode["USAGE_REPORT"] = "usageReport";
    FeatureCode["FILTERING"] = "filtering";
    FeatureCode["APPROVAL_PROCESS"] = "approvalProcess";
    FeatureCode["PARTNER_FIELD"] = "partnerField";
    FeatureCode["ACCOUNTING_TYPE_FIELD"] = "accountingTypeField";
    FeatureCode["ASSIGN_PERMISSION"] = "assignPermission";
    FeatureCode["HYPERPASTE_MANAGEMENT"] = "hyperpasteManagement";
    FeatureCode["PAYMENT_SLIP_VOUCHER"] = "payslip_voucher";
    FeatureCode["PAYMENT_SLIP_FIELD"] = "payslip_field";
    FeatureCode["PAYMENT_SLIP_MODIFICATION"] = "payslip_modification";
    FeatureCode["PAYMENT_SLIP_JOB"] = "payslip_job";
    FeatureCode["PAYMENT_SLIP_FORMAT"] = "payslip_format";
    FeatureCode["GLOBAL_SEARCH"] = "globalSearch";
})(FeatureCode = exports.FeatureCode || (exports.FeatureCode = {}));
var FeatureActionType;
(function (FeatureActionType) {
    FeatureActionType["READ"] = "read";
    FeatureActionType["WRITE"] = "write";
})(FeatureActionType = exports.FeatureActionType || (exports.FeatureActionType = {}));
var IpRestrictionType;
(function (IpRestrictionType) {
    IpRestrictionType["UI"] = "ui";
    IpRestrictionType["API"] = "api";
})(IpRestrictionType = exports.IpRestrictionType || (exports.IpRestrictionType = {}));
